import { forwardRef } from 'react';
import cn from 'clsx';

import styles from './Slide.module.css';

export interface SlideProps {
  className?: string;
  children: React.ReactNode;
}

export const Slide = forwardRef<HTMLLIElement, SlideProps>(({ className, children }, ref) => (
  <li className={cn(styles.slide, className)} ref={ref}>
    {children}
  </li>
));

Slide.displayName = 'Slide';
